/**
 * Style constants for drawing-core primitives.
 *
 * These are the base values used across all drawing tools (takeoff, HITL, master-plan).
 * Tool-specific extensions can override these values via style config parameters.
 */
export const Style = {
	line: {
		thickness: {
			normal: 3,
			highlighted: 4,
			muted: 2,
		},
		hitAreaPadding: 10,
		opacity: {
			normal: 1,
			highlighted: 1,
			muted: 0.3,
		},
		color: {
			fallback: 0x000000,
		},
	},
	point: {
		radius: {
			normal: 4,
			highlighted: 4,
			muted: 4,
		},
		opacity: {
			normal: 0,
			highlighted: 1,
			muted: 0,
		},
		color: {
			fallback: 0x000000,
		},
		border: {
			color: 0x007bff,
			width: 2,
		},
	},
	polygonFill: {
		opacity: {
			normal: 0.2,
			highlighted: 0.3,
			muted: 0.1,
		},
		color: {
			fallback: 0x000000,
		},
	},
	hoverOutline: {
		width: 1,
		color: 0x000000,
		alpha: 1,
	},
	measurement: {
		text: {
			line: {
				minSize: 8,
				maxSize: 16,
				baseSize: 14,
			},
			area: {
				minSize: 10,
				maxSize: 20,
				baseSize: 16,
			},
		},
		outline: {
			label: 'measurement-outline',
		},
		pill: {
			// Pill width is estimated from a worst-case label (the widest realistic
			// measurement string) times a per-character width factor, rather than
			// measured per frame.
			maxText: '99\' 11 3/4"',
			textWidthFactor: 0.54,
			maxLineRatio: 0.8,
		},
	},
} as const;
